<div class="h-screen flex bg-white overflow-x-hidden">

  <!-- SIDEBAR -->
  <aside class="fixed md:relative z-40 h-full bg-gray-900 text-gray-200 flex flex-col
      transition-all duration-300 md:translate-x-0 overflow-hidden" [class.w-64]="l_userAuthenticated && sideNavOpen"
    [class.w-0]="l_userAuthenticated && !sideNavOpen" [class.-translate-x-full]="!sideNavOpen"
    [class.translate-x-0]="sideNavOpen">

    <!-- Logo -->
    <div *ngIf="l_userAuthenticated" class="h-16 flex shrink-0 items-center border-b border-gray-600">
      <!-- <span class="font-medium text-lg text-white tracking-wide">SmartPing</span> -->
      <img src="assets/logos/smart_ping_logo_transparent.png" alt="SmartPing Logo"
        class="items-center h-20 w-60 object-contain">
      <!-- <span class="flex items-center">Smart Piing</span> -->
    </div>

    <!-- Menu -->
    <div *ngIf="l_userAuthenticated" class="flex-1 overflow-y-auto px-2 py-2">
      <ng-container *ngFor="let menu of navItems; let i=index">
        <!-- Top -->
        <div class="flex items-center px-3 py-2 rounded cursor-pointer hover:bg-gray-800" (click)="toggleMenu(i)">
          <span class="material-icons text-[13px] text-slate-400 mr-3">
            {{ menu.icons }}
          </span>
          <span class="flex-1 text-[10px] font-semibold tracking-widest uppercase text-slate-200">
            {{ menu.name }}
          </span>
          <span *ngIf="menu.children" class="material-icons text-sm transition-transform"
            [class.rotate-180]="expandedIndexes.has(i)">
            expand_more
          </span>
        </div>

        <!-- Level 1 -->
        <div *ngIf="expandedIndexes.has(i)" class="ml-4 mt-1">
          <ng-container *ngFor="let child of menu.children; let j=index">
            <div *ngIf="child.children"
              class="flex items-center px-3 py-2 text-sm cursor-pointer rounded hover:bg-gray-800"
              (click)="toggleSubMenu(i,j)">
              <span class="material-icons text-sm mr-2">{{child.icons}}</span>
              <span class="flex-1">{{child.name}}</span>
              <span class="material-icons text-sm" [class.rotate-180]="expandedSubIndexes.has(i+'-'+j)">
                expand_more
              </span>
            </div>
            <div *ngIf="expandedSubIndexes.has(i+'-'+j)" class="ml-4">
              <a *ngFor="let sub of child.children" [routerLink]="sub.path"
                class="block px-3 py-2 text-xs text-slate-300 no-underline rounded hover:bg-gray-700 hover:text-white">
                {{ sub.name }}
              </a>
            </div>
            <a *ngIf="!child.children" [routerLink]="child.path"
              class="flex items-center px-3 py-2 text-sm text-slate-300 no-underline rounded hover:bg-gray-800 hover:text-white">
              <span class="material-icons text-[13px] text-slate-400 mr-2">
                {{ child.icons }}
              </span>
              <span>{{ child.name }}</span>
            </a>
          </ng-container>
        </div>

      </ng-container>
    </div>

    <!-- Sidebar Footer Area -->
    <div *ngIf="l_userAuthenticated" class="shrink-0 flex flex-col border-t border-gray-800 bg-gray-900">

      <!-- Mobile Client/User Info -->
      <div class="md:hidden flex flex-col gap-2 px-4 py-1 border-b border-gray-800 bg-gray-800/40">
        <div class="flex items-center gap-2">
          <span class="material-icons text-gray-400 text-sm">person</span>
          <span class="text-xs font-medium text-gray-200 tracking-wide uppercase truncate">
            {{ fullName }}
          </span>
        </div>
      </div>

      <!-- Copyright Footer -->
      <div class="flex flex-col items-center justify-center py-3">
        <span class="text-[10px] font-semibold tracking-wider text-gray-400 uppercase text-center">
          Concurrency Global 2026 ©
        </span>
      </div>
    </div>
  </aside>

  <!-- Mobile Backdrop -->
  <div *ngIf="l_userAuthenticated && sideNavOpen" class="fixed inset-0 bg-black/50 z-30 md:hidden transition-opacity"
    (click)="sideNavOpen = false">
  </div>

  <!-- MAIN -->
  <div class="flex-1 flex flex-col min-w-0">

    <!-- TOP BAR -->
    <header *ngIf="l_userAuthenticated"
      class="h-16 bg-gray-950 text-white flex items-center justify-between px-4 relative z-50">

      <!-- LEFT -->
      <div class="flex items-center space-x-3">
        <button *ngIf="l_userAuthenticated" (click)="sideNavOpen = !sideNavOpen"
          class="p-2 rounded-md hover:bg-gray-800 focus:outline-none">
          <span class="material-icons">menu</span>
        </button>
        <!-- MOBILE CLIENT NAME (Visible only on mobile next to hamburger) -->
        <div *ngIf="l_userAuthenticated"
          class="md:hidden flex items-center gap-1.5 px-1 py-1 rounded bg-gray-800 border border-gray-700 max-w-[120px]">
          <span class="material-icons text-gray-300 text-sm">business</span>
          <span class="text-xs font-medium text-gray-200 tracking-wide uppercase">
            {{ clientName }}
          </span>
        </div>
      </div>

      <!-- RIGHT USER SECTION -->
      <div *ngIf="l_userAuthenticated" class="relative flex items-center gap-2 sm:gap-3">

        <!-- TEST ENVIRONMENT BADGE -->
        <div *ngIf="isTestEnvironment"
          class="flex items-center gap-1.5 px-2 py-1 sm:px-3 sm:py-1.5 rounded bg-gray-800 border border-gray-700">
          <span class="material-icons text-gray-300 text-sm">science</span>
          <span class="text-xs font-medium text-gray-200 tracking-wide uppercase">
            <span class="hidden sm:inline">Test Environment</span>
            <span class="sm:hidden">Test</span>
          </span>
        </div>

        <!-- CLIENT NAME (Hidden on Mobile) -->
        <div class="hidden md:flex items-center gap-2 px-3 py-1.5 rounded bg-gray-800 border border-gray-700">
          <span class="material-icons text-gray-300 text-sm">business</span>
          <span
            class="text-xs font-medium text-gray-200 tracking-wide uppercase truncate max-w-[150px] lg:max-w-none">{{
            clientName }}</span>
        </div>

        <!-- USER NAME (Hidden on Extra Small Screens) -->
        <div class="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded bg-gray-800 border border-gray-700">
          <span class="material-icons text-gray-300 text-sm">person</span>
          <span
            class="text-xs font-medium text-gray-200 tracking-wide uppercase truncate max-w-[120px] lg:max-w-none">{{
            fullName }}</span>
        </div>

        <!-- SETTINGS WRAPPER (HOVER & CLICK FOR MOBILE) -->
        <div class="relative" (mouseenter)="settingsOpen = true" (mouseleave)="settingsOpen = false"
          (click)="settingsOpen = !settingsOpen">
          <!-- SETTINGS ICON -->
          <button class="p-2 rounded-full hover:bg-gray-800 transition">
            <span class="material-icons text-gray-300">settings</span>
          </button>

          <!-- SETTINGS DROPDOWN -->
          <div *ngIf="settingsOpen"
            class="absolute right-0 top-10 w-45 bg-gray-900 rounded-lg shadow-2xl border border-gray-700 py-2 z-50">

            <button class="flex items-center w-full px-3 py-2.5 text-medium text-gray-300 hover:bg-gray-800 gap-2">
              <span class="material-icons text-lg">person</span>
              Profile
            </button>

            <!-- <button class="flex items-center w-full px-3 py-2.5 text-xs text-gray-300 hover:bg-gray-800 gap-2">
              <span class="material-icons text-lg">lock</span>
              Change Password
            </button> -->

            <button class="flex items-center w-full px-3 py-2.5 text-medium text-gray-300 hover:bg-gray-800 gap-2">
              <span class="material-icons text-lg">tune</span>
              Preferences
            </button>

            <div class="border-t border-gray-700"></div>

            <button class="flex items-center w-full px-3 py-2.5 text-medium text-red-400 hover:bg-red-900/30 gap-2"
              (click)="lFN_LogoutUser()">
              <span class="material-icons text-lg">logout</span>
              Sign Out
            </button>

          </div>
        </div>

      </div>

    </header>


    <!-- CONTENT -->
    <main class="flex-1 min-w-0" [ngClass]="{
        'bg-neutral-100 overflow-hidden p-0': !l_userAuthenticated,
        'bg-neutral-100 overflow-auto p-4 sm:p-6': l_userAuthenticated
      }">

      <!-- LOGIN -->
      <div *ngIf="!l_userAuthenticated" class="h-full flex items-center justify-center">

        <router-outlet></router-outlet>

      </div>

      <!-- APP -->
      <div *ngIf="l_userAuthenticated">

        <app-loader></app-loader>

        <router-outlet></router-outlet>

      </div>

    </main>

  </div>

</div>